import script from "./ZcList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ZcList.vue?vue&type=script&lang=ts&setup=true"

import "./ZcList.vue?vue&type=style&index=0&id=205f5188&lang=scss"

const __exports__ = script;

export default __exports__